import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from "history";

export let appInsights: ApplicationInsights | undefined = undefined;

export function getAppInsights() {
    return appInsights;
}

export const reactPlugin = new ReactPlugin();

export function init(connectionString: string) {
    const browserHistory = createBrowserHistory({ basename: '' });

    appInsights = new ApplicationInsights({
        config: {
            connectionString: `${connectionString}`,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history: browserHistory }
            }
        }
    });

    appInsights.loadAppInsights();

    appInsights.addTelemetryInitializer((envelope) => {
        // set cloud_RoleName
        if (!envelope.tags) {
            envelope.tags = [];
        }
        envelope.tags.push({ "ai.cloud.role": "BusinessPortal.Web" });
    });
}